import {
  put, takeLatest, all, delay, call, take, select, takeEvery,
} from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
import v4 from 'uuid/v4';
import {
  GIOTALK_ABANDONAR_CHAT,
  GIOTALK_ABANDONAR_CHAT_FAILURE,
  GIOTALK_ABANDONAR_CHAT_SUCCESS, GIOTALK_ABRIR_CHAT_CON_USUARIO,
  GIOTALK_CHANNEL_SETTINGS_UPDATE_FAILURE,
  GIOTALK_CHANNEL_SETTINGS_UPDATE_REQUEST,
  GIOTALK_CHANNEL_SETTINGS_UPDATE_SUCCESS,
  GIOTALK_CHAT_ELIMINAR,
  GIOTALK_CHATS_CREAR_ADD_PENDIENTE,
  GIOTALK_CHATS_CREAR_FAILURE,
  GIOTALK_CHATS_CREAR_REQUEST,
  GIOTALK_CHATS_CREAR_SUCCESS,
  GIOTALK_CHATS_ENVIAR_MENSAJE_A_CHAT_FAILURE,
  GIOTALK_CHATS_ENVIAR_MENSAJE_A_CHAT_REQUEST,
  GIOTALK_CHATS_ENVIAR_MENSAJE_A_CHAT_SUCCESS,
  GIOTALK_CHATS_ESTABLECER_ULTMO_MENSAJE,
  GIOTALK_CHATS_MENSAJES_ADD_PENDIENTE,
  GIOTALK_CHATS_MENSAJES_BUSCAR_MENSAJES_CARGAR,
  GIOTALK_CHATS_MENSAJES_BUSCAR_MENSAJES_FAILURE,
  GIOTALK_CHATS_MENSAJES_BUSCAR_MENSAJES_REQUEST,
  GIOTALK_CHATS_MENSAJES_BUSCAR_MENSAJES_SUCCESS,
  GIOTALK_CHATS_MENSAJES_CONFIRMAR_ENVIO,
  GIOTALK_CHATS_OBTENER_CARGAR,
  GIOTALK_CHATS_OBTENER_FAILURE,
  GIOTALK_CHATS_OBTENER_REQUEST,
  GIOTALK_CHATS_OBTENER_SUCCESS,
  GIOTALK_ESTABLECER_CONNECIONID, GIOTALK_INICIAR_CONEXION_WS, GIOTALK_INSERTAR_USUARIOS_A_CHAT,
  GIOTALK_INSERTAR_USUARIOS_FAILURE,
  GIOTALK_INSERTAR_USUARIOS_REQUEST,
  GIOTALK_INSERTAR_USUARIOS_SUCCESS,
  GIOTALK_NOTIFICACIONES_SUSCRIPCIONES_FAILURE,
  GIOTALK_NOTIFICACIONES_SUSCRIPCIONES_REQUEST,
  GIOTALK_NOTIFICACIONES_SUSCRIPCIONES_SUCCESS,
  GIOTALK_OBTENER_NOTIFICACIONES_FAILURE,
  GIOTALK_OBTENER_NOTIFICACIONES_REQUEST,
  GIOTALK_OBTENER_NOTIFICACIONES_SUCCESS,
} from '../actions/constants/giotalk.constants';
import {
  incrementarNoLeidas,
  establecerNumerosNotificaciones,
  marcarNotificacionesLeidas,
  obtenerNotificacionesDesdeSevidor,
  establecerSubscripcionesNotificaciones,
  buscarMensajes,
  obtenerChatsDesdeServidor,
} from '../actions/creators/giotalk.actioncreator';
import { AUTH_SUCCESS } from '../actions/constants/auth.constants';
import { authRequest } from '../../helpers/request.helper';
import { sendMessageGW1 } from '../../helpers/GW1sendMessage.helper';

const gioTalkState = state => state.giotalk;
const authState = state => state.auth;

function websocketInitChannel() {
  return eventChannel((emitter) => {
    // init the connection here
    const ws = new WebSocket('wss://djiyappthc.execute-api.eu-west-1.amazonaws.com/Preproduccion'
      + '?QueryString1=WebsocketSeguroQSParaClientes2019GIO');

    ws.onopen = (e) => {
      ws.send(null);
      setInterval(() => {
        ws.send(null);
      }, 9 * 60 * 1000);
    };

    ws.onmessage = (event) => {
      emitter({ type: 'ACTION', payload: { event } });
    };

    return () => {

    };
  });
}


function* emitirTotalNotificacionesGW1() {
  const giotalk = yield select(gioTalkState);
  const { notificaciones, chats } = giotalk;
  const { totalNoLeido } = notificaciones;
  let total = 0;
  if(totalNoLeido !== undefined) {
    total += totalNoLeido;
  }
  for (let i = 0; i < chats.length; i++) {
    const chat = chats[i];
    const { totalNoLeido } = chat;
    if(totalNoLeido !== undefined) {
      total += totalNoLeido;
    }
  }
  sendMessageGW1({
    action: 'NOTIFICACIONES_ESTABLECER_DATOS',
    payload: { totalNoLeido: total },
  });
  console.error(`Total ${total}`);
}

function* iniciarConexionWS() {
  const channel = yield call(websocketInitChannel);

  while (true) {
    const action = yield take(channel);
    const giotalk = yield select(gioTalkState);
    const { connectionId } = giotalk;
    const esNecesariaAutenticacion = connectionId === null;
    const { payload } = action;
    const { event: { data } } = payload;
    if (esNecesariaAutenticacion) {
      try {
        const jsonData = JSON.parse(data);
        const { connectionId } = jsonData;
        if (connectionId) {
          yield put({ type: GIOTALK_ESTABLECER_CONNECIONID, payload: { connectionId } });
        }
        const formData = new FormData();
        formData.append('connectionId', connectionId);

        const params = {
          url: 'api/notificaciones/autenticarSocket',
          method: 'POST',
          body: formData,
        };
        yield call(authRequest, params);
        yield put(obtenerNotificacionesDesdeSevidor({ marcarComoLeido: false }));
      } catch (ex) {}
    } else {
      try {
        const jsonData = JSON.parse(data);
        const { type, chat } = jsonData;
        const giotalk = yield select(gioTalkState);
        if (type === 'notification') {
          yield put(incrementarNoLeidas({ total: type }));
          const { notificaciones: { totalNoLeido } } = giotalk;
          sendMessageGW1({
            action: 'NOTIFICACIONES_ESTABLECER_DATOS',
            payload: { totalNoLeido },
          });
        } else if (chat) {
          const { chatSeleccionadoId } = giotalk;
          if (chatSeleccionadoId != null && chatSeleccionadoId != undefined) {
            yield put(buscarMensajes({ chatId: chat, primeraCarga: true }));
          }
          yield put(obtenerChatsDesdeServidor());
        }
      } catch (ex) {}
    }
  }
}

function* obtenerNotificaciones({ payload: { marcarComoLeido } }) {
  try {
    const giotalk = yield select(gioTalkState);
    const { notificaciones: { mensajes } } = giotalk;
    const limit = 10;
    const skip = mensajes.length;
    const params = {
      url: 'api/notificaciones/listar',
      method: 'POST',
      body: {
        marcarComoLeido,
        limit,
        skip,
      },
    };
    const respuesta = yield call(authRequest, params);
    const { totalMessagesCount, totalNotReadMessagesCount, datos } = respuesta;
    const payload = {
      total: totalMessagesCount,
      totalNoLeido: totalNotReadMessagesCount,
      datos: [...mensajes, ...datos],
    };
    yield put(establecerNumerosNotificaciones(payload));
    yield put({ type: GIOTALK_OBTENER_NOTIFICACIONES_SUCCESS });
    if (marcarComoLeido) {
      yield put(marcarNotificacionesLeidas());
      payload.totalNoLeido = 0;
    }
    sendMessageGW1({ action: 'NOTIFICACIONES_ESTABLECER_DATOS', payload });
  } catch (ex) {
    yield put({ type: GIOTALK_OBTENER_NOTIFICACIONES_FAILURE, payload: { ex } });
  }
}

function* obtenerSuscripciones() {
  try {
    const params = {
      url: 'api/notificaciones/suscripciones/listar',
      method: 'POST',
    };
    const respuesta = yield call(authRequest, params);
    const { datos: subscripciones } = respuesta;
    yield put(establecerSubscripcionesNotificaciones({ subscripciones }));
    yield put({ type: GIOTALK_NOTIFICACIONES_SUSCRIPCIONES_SUCCESS });
  } catch (ex) {
    yield put({ type: GIOTALK_NOTIFICACIONES_SUSCRIPCIONES_FAILURE, payload: { ex } });
  }
}


function* actualizarOpcionesDeCanal({ payload: { opciones } }) {
  try {
    const { subscripciones: subscripcionesRequest } = opciones;
    const params = {
      url: 'api/notificaciones/suscripciones/actualizar',
      method: 'POST',
      body: {
        subscripciones: subscripcionesRequest,
      },
    };
    const respuesta = yield call(authRequest, params);
    const { datos: subscripciones } = respuesta;
    yield put(establecerSubscripcionesNotificaciones({ subscripciones }));
    yield put({ type: GIOTALK_CHANNEL_SETTINGS_UPDATE_SUCCESS });
  } catch (error) {
    yield put({ type: GIOTALK_CHANNEL_SETTINGS_UPDATE_FAILURE });
  }
}

function* enviarMensajeAChat({ payload: { chatId, mensaje: contenidoMensaje } }) {
  const mensajeId = v4();
  try {
    const mensaje = {
      id: mensajeId,
      content: contenidoMensaje,
      pending: true,
      mine: true,
      date: new Date(),
    };
    yield put({ type: GIOTALK_CHATS_MENSAJES_ADD_PENDIENTE, payload: { chatId, mensaje } });
    yield delay(100);
    window.scrollTo(0, document.body.scrollHeight);
    const params = {
      url: `api/chats/${chatId}/mensajes/crear`,
      method: 'POST',
      body: {
        content: contenidoMensaje,
      },
    };
    yield call(authRequest, params);

    yield put({ type: GIOTALK_CHATS_ENVIAR_MENSAJE_A_CHAT_SUCCESS });
    yield put({ type: GIOTALK_CHATS_MENSAJES_CONFIRMAR_ENVIO, payload: { chatId, mensajeId } });
    yield put({ type: GIOTALK_CHATS_ESTABLECER_ULTMO_MENSAJE, payload: { chatId, mensaje } });

    // TODO WEBSOCKET ENVIAR MENSAJE
  } catch (ex) {
    yield put({ type: GIOTALK_CHATS_ENVIAR_MENSAJE_A_CHAT_FAILURE, payload: { ex } });
  }
}

function* crearChatEnServidor({ payload: { name, usuarios } }) {
  try {
    const params = {
      url: 'api/chats/crear',
      method: 'POST',
      body: {
        usuarios,
        nombre: name,
      },
    };

    const { datos: { insertedId: id }, empresa, usuarioId } = yield call(authRequest, params);

    const resultUsuarios = [];
    resultUsuarios.push({ company: empresa, intUser: usuarioId });
    Object.keys(usuarios).forEach((id) => {
      resultUsuarios.push({
        company: empresa,
        intUser: id,
      });
    });

    yield put({ type: GIOTALK_CHATS_CREAR_ADD_PENDIENTE, payload: { name, usuarios: resultUsuarios, id } });

    yield put({ type: GIOTALK_CHATS_CREAR_SUCCESS });
  } catch (ex) {
    yield put({ type: GIOTALK_CHATS_CREAR_FAILURE, payload: { ex } });
  }
}

function* obtenerChatsFromDB() {
  try {
    const params = {
      url: 'api/chats/listar',
      method: 'POST',
    };
    const { datos: chats } = yield call(authRequest, params);
    const chatsMapped = chats.map((chat) => {
      const {
        _id, name, lastMessage, totalNoLeido, createdAt, users,
      } = chat;
      return {
        id: _id,
        nombre: name,
        mensajes: [],
        lastMessage,
        totalNoLeido,
        createdAt,
        usuarios: users,
      };
    });
    yield put({ type: GIOTALK_CHATS_OBTENER_SUCCESS });
    yield put({ type: GIOTALK_CHATS_OBTENER_CARGAR, payload: { chats: chatsMapped } });
    yield emitirTotalNotificacionesGW1();
  } catch (ex) {
    yield put({ type: GIOTALK_CHATS_OBTENER_FAILURE, payload: { ex } });
  }
}

function* obtenerMensajesDeChatDesdeServidor({ payload: { chatId, primeraCarga = false } }) {
  try {
    const giotalk = yield select(gioTalkState);
    const { chats } = giotalk;
    const chat = chats.find(({ id }) => id == chatId);
    const { mensajes: mensajesYaCargados } = chat;

    const limit = 100;
    const requestSkip = (primeraCarga) ? 0 : mensajesYaCargados.length;

    const params = {
      url: `api/chats/${chatId}/mensajes`,
      method: 'POST',
      body: {
        limit,
        skip: requestSkip,
      },
    };

    const { datos: mensajes, total, mensajesPorLeerDeEsteChat, totalDeMensajesPorLeer } = yield call(authRequest, params);

    const mensajesMapped = mensajes.map((mensaje) => {
      const {
        _id, content, mine, date, author,
      } = mensaje;
      return {
        id: _id,
        content,
        mine,
        date,
        author,
        pending: false,
      };
    });
    const ids = new Set(mensajesYaCargados.map(d => d.id));
    const mensajesOutput = [...mensajesMapped.filter(d => !ids.has(d.id)), ...mensajesYaCargados.filter(d => (d.pending !== true && d.author != undefined ))].sort((mensajeA, mensajeB) => {
      const { date: dateA } = mensajeA;
      const { date: dateB } = mensajeB;
      if (new Date(dateA).getTime() > new Date(dateB).getTime()) return 1;
      return -1;
    });
    yield put({ type: GIOTALK_CHATS_MENSAJES_BUSCAR_MENSAJES_SUCCESS });
    yield put({ type: GIOTALK_CHATS_MENSAJES_BUSCAR_MENSAJES_CARGAR, payload: { chatId, mensajes: mensajesOutput, total, totalNoLeido: mensajesPorLeerDeEsteChat } });
    sendMessageGW1({
      action: 'NOTIFICACIONES_ESTABLECER_DATOS',
      payload: { totalNoLeido: totalDeMensajesPorLeer },
    });
  } catch (ex) {
    yield put({ type: GIOTALK_CHATS_MENSAJES_BUSCAR_MENSAJES_FAILURE, payload: { ex } });
  }
}

function* abandonarChat({ payload: { chatId } }) {
  try {
    const params = {
      url: `api/chats/${chatId}/abandonar`,
      method: 'POST',
    };
    yield call(authRequest, params);
    yield put({ type: GIOTALK_CHAT_ELIMINAR, payload: { chatId } });
    yield put({ type: GIOTALK_ABANDONAR_CHAT_SUCCESS });
  } catch (ex) {
    yield put({ type: GIOTALK_ABANDONAR_CHAT_FAILURE });
  }
}

function* insertarUsuariosEnChat({ payload: { chatId, usuarios } }) {
  try {
    const params = {
      url: `api/chats/${chatId}/insertarUsuarios`,
      method: 'POST',
      body: {
        usuarios,
      },
    };
    const { usuariosInsertados } = yield call(authRequest, params);
    yield put({ type: GIOTALK_INSERTAR_USUARIOS_A_CHAT, payload: { chatId, usuarios: usuariosInsertados } });
    yield put({ type: GIOTALK_INSERTAR_USUARIOS_SUCCESS });
  } catch (ex) {
    yield put({ type: GIOTALK_INSERTAR_USUARIOS_FAILURE });
  }
}

function* abrirChatConUsuario({ payload: { usuario } }) {
  try {
    const giotalkState = yield select(gioTalkState);
    const auth = yield select(authState);
    const { user: { cliente_deipe, user_info: { usuario_id } } } = auth;
    const { intUser, company } = usuario;
    const { chats } = giotalkState;
    const chatConUsuario = chats.filter((chat) => {
      const { usuarios } = chat;
      if (usuarios && usuarios.length === 2) {
        const yo = usuarios.find(({ id, company }) => id === usuario_id && company === cliente_deipe);
        const usuarioObjetivo = usuarios.find(({ id: idS, company: companyS }) => idS === intUser && companyS === company);
        if (yo !== undefined && usuarioObjetivo !== undefined) {
          return true;
        }
      }
      return false;
    });
  } catch (ex) {

  }
}

function* giotalkSaga() {
  yield all([
    takeLatest(GIOTALK_CHANNEL_SETTINGS_UPDATE_REQUEST, actualizarOpcionesDeCanal),
    takeLatest(GIOTALK_INICIAR_CONEXION_WS, iniciarConexionWS),
    takeLatest(GIOTALK_OBTENER_NOTIFICACIONES_REQUEST, obtenerNotificaciones),
    takeLatest(GIOTALK_NOTIFICACIONES_SUSCRIPCIONES_REQUEST, obtenerSuscripciones),
    takeEvery(GIOTALK_CHATS_ENVIAR_MENSAJE_A_CHAT_REQUEST, enviarMensajeAChat),
    takeLatest(GIOTALK_CHATS_CREAR_REQUEST, crearChatEnServidor),
    takeLatest(GIOTALK_CHATS_OBTENER_REQUEST, obtenerChatsFromDB),
    takeLatest(GIOTALK_CHATS_MENSAJES_BUSCAR_MENSAJES_REQUEST, obtenerMensajesDeChatDesdeServidor),
    takeLatest(GIOTALK_INSERTAR_USUARIOS_REQUEST, insertarUsuariosEnChat),
    takeLatest(GIOTALK_ABANDONAR_CHAT, abandonarChat),
    takeLatest(GIOTALK_ABRIR_CHAT_CON_USUARIO, abrirChatConUsuario),
  ]);
}

export default giotalkSaga;
